import { Controller } from "stimulus"
import scrollIntoView from 'scroll-into-view-if-needed'

const timeExpando = "__transcript_scroll_timespan"

function stepMatchesTime(el, ts) {
  const [ start, end ] = el[timeExpando]
  return start <= ts && ts <= end
}

function scrollTo(el) {
  scrollIntoView(el, { block: 'center', inline: 'start', boundary: el.parentNode })
}

export default class extends Controller {
  static targets = [ "step" ]

  stepTargetConnected(el) {
    try {
      if (!el[timeExpando]) {
        el[timeExpando] = JSON.parse(el.dataset.time)
      }
    } catch {
      // no-op
    }
  }

  handle = ({ detail: { audioTag } }) => {
    const nextStep = this.stepTargets.find(el => stepMatchesTime(el, audioTag.currentTime))

    if (!nextStep || this._currentStep == nextStep) { return }
    this._currentStep = nextStep

    scrollTo(nextStep)
  }
}
